import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDeliveryCompanies } from 'src/api/delivery-company';
import { AppState } from 'src/store';
import { initialState } from './state';

export const getDeliveryCompanyList = createAsyncThunk(
    `deliveryCompanySlice/getDeliveryCompanyList`,
    async (_, { rejectWithValue }) => {
        try {
            const res = await getDeliveryCompanies();
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
    {
        condition: (_, { getState }) => {
            const { deliveryCompanyList } = (getState() as AppState).deliveryCompanySlice;
            return deliveryCompanyList.length === 0;
        },
    },
);

export const deliveryCompanySlice = createSlice({
    name: 'deliveryCompanySlice',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getDeliveryCompanyList.fulfilled, (state, { payload }) => {
            state.deliveryCompanyList = payload;
        });
    },
});

export default deliveryCompanySlice.reducer;
// export const {} = deliveryCompanySlice.actions;
